<template>
  <div>
    <transition name="fade">
      <div class="bg-preloader" v-if="startPreloader"></div>
    </transition>
    <div class="ccode"></div>
    <main class="main-page">
      <transition name="fade">
        <infinity-preloader :startPreloader="startPreloader" class="infinity-preloader-main-page"></infinity-preloader>
      </transition>

      <!-- ГЛАВНЫЙ СЛАЙДЕР ТАЙТЛОВ -->
      <main-page-slider :isSearchText="searchText"></main-page-slider>
      <!-- ГЛАВНЫЙ СЛАЙДЕР ТАЙТЛОВ END-->

      <!-- ПОИСК -->
      <div class="search-anime">
          <input  @input="searchAnime" @keyup="ccode($event)" @focus="isSearchFocus = true" @blur="isSearchFocusFunc" type="text" name="inputAnime" placeholder="Поиск" autocomplete="off">
          <router-link to="/filter">
            <i class='fas fa-sliders-h'></i>
          </router-link>
        
      </div>
      <!-- ПОИСК END -->


     
      <!-- HASHTAG НАЗВАНИЕ -->
      <div class="hashtag-title" style="max-width: 1030px; width: 100%;margin: -5px auto;">
        <h3>{{ decodeURI(hashtagTitle) }}</h3>
      </div>
      <!-- HASHTAG НАЗВАНИЕ END-->


      <div class="anime-swipers">

        <!-- WATCHING BLOCK IF LOGGED -->
        <watching-anime v-if="isAuthedAndMain" v-show="show_title_cards_block"></watching-anime>
        <!-- WATCHING BLOCK IF LOGGED END -->


        <!-- TITLES BLOCKS SCROLL -->
        <router-link to="/new_2023" v-show="show_title_cards_block">
          <h2 class="header_type_title upper">Новинки 2025 <i class="fas fa-chevron-right fa-xs"></i></h2>
        </router-link>
        <anime-new-swiper-block v-show="show_title_cards_block" :props_url="new_anime_url"></anime-new-swiper-block>
        <router-link to="/movie" v-show="show_title_cards_block">
          <h2 class="header_type_title">Полнометражные <i class="fas fa-chevron-right fa-xs"></i></h2>
        </router-link>
        <anime-new-swiper-block v-show="show_title_cards_block" :props_url="movie_anime_url"></anime-new-swiper-block>
        <router-link to="/tv" v-show="show_title_cards_block">
          <h2 class="header_type_title">Сериалы <i class="fas fa-chevron-right fa-xs"></i></h2>
        </router-link>
        <anime-new-swiper-block v-show="show_title_cards_block" :props_url="serial_anime_url"></anime-new-swiper-block>
        <router-link to="/ova" v-show="show_title_cards_block">
          <h2 class="header_type_title upper">OVA <i class="fas fa-chevron-right fa-xs"></i></h2>
        </router-link>
        <anime-new-swiper-block v-show="show_title_cards_block" :props_url="ova_anime_url"></anime-new-swiper-block>
        <router-link to="/ona" v-show="show_title_cards_block">
          <h2 class="header_type_title upper">ONA <i class="fas fa-chevron-right fa-xs"></i></h2>
        </router-link>
        <anime-new-swiper-block v-show="show_title_cards_block" :props_url="ona_anime_url"></anime-new-swiper-block>
        <!-- TITLES BLOCKS SCROLL END -->

        <anime-list-cards :anime_list="animeList"></anime-list-cards>
        
      </div>
    </main>
    <button-page-up></button-page-up>
    
  </div>
</template>

<script>
//БИБЛИОТЕКИ
import axios from "axios";


// КОМПОНЕНТЫ IMPORT
import KindAnime from '@/widgets/KindAnime.vue'
import WatchingAnime from '@/widgets/WatchingAnime.vue'
import AnimeNewSwiper from '@/widgets/AnimeNewSwiper.vue'
import isBugButton from '@/shared/ui/buttons/isBugButton.vue'
import ButtonPageUp from '@/shared/ui/buttons/ButtonPageUp.vue'
import InfinityPreloader from "@/widgets/InfinityPreloader.vue";
import TitlesFilter from "@/widgets/TitlesFilter.vue";
import AnimeListCards from "@/widgets/AnimeListCards.vue";
// КОМПОНЕНТЫ IMPORT END

//HELPERS
import {removeDuplicatesG} from "@/shared/lib/helpers.js";
import {getAndShowThemeG, setHeadTitleG} from "@/shared/helpers/messy-helpers.js";
import MainPageSlider from "@/widgets/MainPageSlider.vue";


export default {
  data() {
    return {
      url: "",
      urlBasic: "https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial",
      search_anime_url: 'https://kodikapi.com/search?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial&title=',
      main_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=movie,tv&sort=created_at&limit=100',
      new_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial&year=2025',
      movie_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=movie',
      serial_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=tv&year=2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012',
      ova_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=ova',
      ona_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=ona',
      animeList: {},
      searchText: "",
      isMainPage: true,
      hashtagTitle: "",
      audio: "",
      watching_list: [],
      isAuthedAndMain: false,
      show_title_cards_block: true,
      startPreloader: false,
      isSearchFocus: false
    };
  },
  //Регистрация компонентов
  components: {
    'kind-anime': KindAnime,
    'watching-anime': WatchingAnime,
    'anime-new-swiper-block': AnimeNewSwiper,
    'is-bug-button': isBugButton,
    'button-page-up': ButtonPageUp,
    'infinity-preloader': InfinityPreloader,
    'titles-filter': TitlesFilter,
    'anime-list-cards': AnimeListCards,
    'main-page-slider': MainPageSlider
  },
  watch:{
    $route(newPath, oldPath){
      this.isAuthedAndMainFunc();
      this.showAnimeMainPage();
    }
  },
  created(){
    //Установка темы
    getAndShowThemeG();
    //Авторизация 
    this.isAuthedAndMainFunc();

    //Если главная, то меняем название вкладки страницы  и отрисовываем тайтлы главной страницы
    if(window.location.pathname === '/'){ //Главная страница
      if(!localStorage.getItem('searchText')){
        setHeadTitleG('Anione');
        this.showAnimeMainPage();
      }
    }else{
      this.showAnimeMainPage(window.location.pathname);//Разные urls
    }

    //Аудио чит-кода
    this.audio = new Audio(`${window.location.protocol}//${window.location.hostname}/cheat.mp3`);

  },
  updated(){
    //Очищаем хэштег, если path /studio или /genre
    if(!(window.location.pathname).includes('studio') && !(window.location.pathname).includes('genre')){
      this.hashtagTitle = "";
    } 
    
    
  },
  mounted(){
    document.querySelector('.search-anime input').value = localStorage.getItem('searchText');
    this.searchAnime();
    let that = this;
    document.querySelector('.header').addEventListener( "click" , () => {
      localStorage.setItem('searchText', "");
      document.querySelector('.search-anime input').value = "";
      that.searchText = "";
      that.showAnimeMainPage();
      that.show_title_cards_block = true;
    });
  },
  methods: {
    ///////////////////////////////////////
    /////////////MAIN ELEMENTS/////////////
    ///////////////////////////////////////

    isSearchFocusFunc(){
      // this.isSearchFocus = false
      setTimeout(() => {
        this.isSearchFocus = false;
      },100);
      
    },
    clearLocalStorageSearchText(){
      localStorage.setItem('searchText', '');
      document.querySelector('.search-anime input').value = "";
    },
    //REFACTORED FUNCTION, NOT CLEAN
    //Получение и отрисовка аниме тайтлов по main_anime_url(Главная страница)
    //@param {string} берет строку страницы сайта
    async showAnimeMainPage(){
      this.animeList = await this.getKodikDataAndRemoveDuplicates(this.main_anime_url);
    },
    //REFACTORED FUNCTION, NOT CLEAN
    //Описание: поиск по аниме с отображением тайтлов + LiveSearch
    async searchAnime() {
      this.searchText = document.querySelector('.search-anime input').value;  //сделать через v-bind или v-model
      this.show_title_cards_block = false;
      this.hashtagTitle = "";
      //Откат на состояние базовой разметки странцы. С базовыми блоками и базовым url.
      if(this.searchText === ""){
        this.showAnimeMainPage();
        this.show_title_cards_block = true;
      }
      localStorage.setItem('searchText', this.searchText);
      let url = this.search_anime_url + this.searchText;
      //Запрос на search url
      this.animeList = await this.getKodikDataAndRemoveDuplicates(url)
    },
    //REFACTORED FUNCTION, NOT CLEAN
    //Описание: Устанавливает название вкладки страницы
    //@param {string} url kodik api
    //@return {array} возвращает массив объектов(аниме тайтлов)
    async getKodikDataAndRemoveDuplicates(url){
      let response = await axios.get(url);
      return removeDuplicatesG(response.data.results);
    },
    
    //REFACTORED FUNCTION, NOT CLEAN
    //Описание: убирает блок "Продолжить просмотр", если пользователь не авторизован
    hideWatchingDueOFSearch: function(){
      if(this.searchText !== ''){
        this.isAuthedAndMain = false;
      }else{
        this.isAuthedAndMain = true;
      }
    },
    //REFACTORED FUNCTION(MAYBE), NOT CLEAN
    //Описание: проверка авторизации пользователя
    isAuthedAndMainFunc: function(){
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id') && window.location.pathname === '/'){
        let url_get_anime_list = `${window.location.protocol}//${window.location.hostname}/api/getAnime_list.php?password_hash=${localStorage.getItem('password_hash')}&user_id=${localStorage.getItem('user_id')}`;
        axios
        .get(url_get_anime_list)
        .then((response) => {
          if(response.data){
            let watch_list = [];
            for(let i = 0;i < response.data.length;i++){
              if (response.data[i].state_of_anime === 'watching') {
                watch_list.push(response.data[i]);
              } 
            }
            if(watch_list.length !== 0){
              this.isAuthedAndMain = true;
            }
            
          }else{
            console.log('Неверный hash и user_id: ' + response.data);
          }
        })
        .catch((error) => {
          alert('Срок сессии истек. Авторизуйтесь заново.')
          console.error(error);
        });
      }else{
        this.isAuthedAndMain = false;
      }
    },

    /////////////////////////////////////////////
    /////////////ADDITIONAL ELEMENTS/////////////
    /////////////////////////////////////////////

    //NOT ENOUGH REFACTORED FUNCTION, NOT CLEAN
    //Описание: устанавливает команды в localStorage и запускает их 
    ccode: function(e){
      let commands = {
        '/logging 0': ['logging', 'disable'],
        '/logging 1': ['logging', 'enable'],
        '/theme white': ['theme', 'white', 'themes/white.css'],
        '/theme not pink':['theme', 'not pink', 'themes/not_pink.css'],
        '/theme pearl': ['theme', 'pearl', 'themes/pearl.css'],
        '/theme black': ['theme', 'black', '#']
      }

      if(e.keyCode == 13){
        for (let command in commands){
          if(this.searchText === command){
            let key = commands[command][0];
            let value = commands[command][1];
            localStorage.setItem(key, value);
            if(key === 'theme'){
              getAndShowThemeG();
            }
            this.showActivatedCheatCode();
          }
        }
      }
    },
    //NOT ENOUGH REFACTORED FUNCTION(USE REFS), NOT CLEAN
    //Описание: Проигрывает звук выполнения команды и показывает popup
    showActivatedCheatCode: function(){
      this.audio.play();
      document.querySelector('.ccode').style.display = 'block';
      document.querySelector('.ccode').style.opacity = '1';
      setTimeout(function(){
        document.querySelector('.ccode').style.opacity = '0';
        setTimeout(function(){document.querySelector('.ccode').style.display = 'none';}, 500);
      },1000);
    }
  }
};
</script>





<style scoped>
/* //////////////////////////////////////CSS///////////////////////////////////////////////// */

/* SHARED */

/* SHARED END */



.bg-preloader{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: black;
  z-index: 1000;
  transform: .3s;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}


.infinity-preloader-main-page{
  position: fixed;
  top: calc(50vh - 35px);
  z-index: 1001;
  transition: .3s;
}




[data-title]:hover:after {
    visibility: visible;
}

.selectr-container{
  color: black;
}

.selectr-container .selectr-input{
  padding: 5px 10px;
}

#select_multiple_genres ul{
  color: black;
}
  
[data-title]:after {
    content: attr(data-title);
    background-color: #262626;    
    color: #ffffff;
    font-size: 80%;
    position: absolute;
    border-radius: 5px;
    border: 1px solid #1d1d1d;
    padding: 4px 8px 4px 8px;
    visibility: hidden;
}




main {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Exo 2", sans-serif;
}

.search-anime{
  position: relative;
  width: 100%;
  max-width: 1000px;
  padding: 0 20px;
  margin-bottom: 20px;
  z-index: 999;
}

.hashtag-title h3{
  text-align: left; 
  margin-left: 16px;
}



.search-anime input{
  width: 100%;
  padding: 10px 20px;
  font-size: 22px;
  font-family: 'Montserrat', sans-serif;
  background: transparent;
  color: white;
  text-align: center;
  box-sizing: border-box;
  backdrop-filter: blur(7px);
  border-radius: 8px;
  border: 1px solid #5555555e;
  background: #ffffff26;
  text-shadow: 1px 1px 2px black;
}

.search-anime input:focus{
  outline: 2px solid #72b5ff;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom:  none;
  box-shadow: 0 0 83px 45px #007aff3d;
  backdrop-filter: blur(3px);
}

.search-anime input::placeholder { /* Most modern browsers support this now. */
  text-shadow: 0 0 1px rgb(53, 53, 53);
  color: rgb(134, 134, 134);
}



.anime-swipers {
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 350px;
}

.ccode{
  width: 359px;
  height: 30px;
  background-color: #2f2f2f;
  position: absolute;
  left: 50px;
  top: 45px;
  padding: 6px 20px;
  background-image: url(https://anione.fun/ccode.jpg);
  background-size: 360px;
  background-repeat: no-repeat;
  display: none;
  transition: .5s;
  z-index: 100;
}

.header_type_title{
  padding-left: 20px;
  margin-bottom: 10px;
  transition: .3s;
}

.header_type_title:hover{
  color: #72b5ff;
}

.header_type_title.upper i{
  transform: translateY(-2px);
}


.fas.fa-chevron-right{
  width: 5px;
}

.search-anime i{
  position: absolute;
  color: #ffffff;
  right: 31px;
  top: 9px;
  font-size: 19px;
  transition: .2s;
  padding: 6px 6px 4px 6px;
  border-radius: 5px;
  border: 1px solid #5555555e;
  border-radius: 5px;
  background: #b7b7b738;
}

.search-anime i:hover{
  color: #3584ff;
  background-color: #b7b7b76e;
}

/*MOBILE*/

@media only screen and (max-width: 600px) {
  .anime-swipers {
    margin-top: 170px;
  }


  .hashtag-title h3{
    margin-left: 30px;
    margin-bottom: 0;
  }

  
  .ccode{
    left: 0px;
    top: 30px;
    transform: scale(0.8);
  }

  

  #first_main{
    margin-left: -5px;

  }
}
</style>